module.exports = __webpack_public_path__ + "img/information-archive.968ea540.png";